import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import type { CommentCollectionType } from '@src/store/comments/comments';
import type { PostCollectionType } from '@src/store/posts/posts';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
    type: PostCollectionType | CommentCollectionType;
    context: 'post' | 'comment' | 'user';
    postKind?: 'community' | 'story';
    className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = props => {
    const { type, context, className } = props;
    const { t } = useTranslation();

    function getTitle() {
        const specificKey = `${context}List.${type}.emptyState.title`;
        const defaultKey = `${context}List.emptyState.title`;
        return t(specificKey, { defaultValue: t(defaultKey) });
    }

    function getSubtitle() {
        const specificKey = `${context}List.${type}.emptyState.subtitle`;
        const defaultKey = `${context}List.emptyState.subtitle`;
        return t(specificKey, { defaultValue: t(defaultKey) });
    }

    return (
        <div className={cn('flex flex-col items-center justify-center py-4 space-y-2 text-center', className)}>
            <Text className="text-lg font-medium text-gray-900 dark:text-gray-50">{getTitle()}</Text>
            <Text enableMultiline={true} className="text-center text-gray-500 dark:text-gray-500">
                {getSubtitle()}
            </Text>
        </div>
    );
};

export default memo(EmptyState);
